<template>
  <div id="answer-time-average-by-month" class="w-full" />
  <TheNoResult
    v-if="noData"
    :image="imgUrl"
    :title="$t('pages.review.reviewAnalyticsPage.chart.noResults.title')"
    :description="$t('pages.review.reviewAnalyticsPage.chart.noResults.description')"
  />
</template>

<script>
import { AnalyticsAreaChart } from '@/components/charts/AnalyticsAreaChart'
import TheNoResult from '@/components/layout/TheNoResult.vue'
import ApexChart from 'apexcharts'
import dayjs from 'dayjs'
import useReview from '@/composables/review'

export default {
  components: {
    TheNoResult
  },
  setup() {
    const { reviewStatistics, tooltipAreaChartContent } = useReview()
    const imgUrl = computed(
      () => `${import.meta.env.VITE_AWS_STORAGE_URL}/review-analytics/review-average-response.png`
    )
    return {
      reviewStatistics,
      tooltipAreaChartContent,
      imgUrl
    }
  },
  data: () => {
    return {
      chartInstance: null,
      chart: new AnalyticsAreaChart(),
      formattedData: []
    }
  },
  computed: {
    data() {
      return this.reviewStatistics.answerTimeAverageByMonth
    },
    noData() {
      return this.formattedData[0]?.data.length === 0
    }
  },
  mounted() {
    this.initChart()
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
  methods: {
    initChart() {
      this.formatData()
      if (!this.noData) {
        const chartElement = this.createElement('answer-time-average-by-month')
        this.setChartFormatters()
        this.chart.setColor(['#5b21b6'])
        this.chart.setSeries(this.formattedData)
        this.chartInstance = new ApexChart(chartElement, this.chart.options)
        this.chartInstance.render()
      }
    },
    createElement(ref) {
      let elem = document.getElementById(ref)
      let chartElement = document.createElement('div')
      chartElement = elem.appendChild(chartElement)
      chartElement.setAttribute('id', `${ref}-apex`)
      return chartElement
    },
    getFormattedDate(value) {
      return dayjs.duration(value, 'hours').format('DD[j] HH[h] mm[m]')
    },
    setChartFormatters() {
      this.chart.options.yaxis.labels.formatter = (value) => {
        return this.getFormattedDate(value)
      }
      this.chart.options.dataLabels.formatter = (value) => {
        return this.getFormattedDate(value)
      }
      this.chart.options.tooltip.custom = ({ series, seriesIndex, dataPointIndex, w }) => {
        var seriesData = w.globals.initialSeries[seriesIndex]
        const value = this.getFormattedDate(series[seriesIndex][dataPointIndex])
        return this.tooltipAreaChartContent(seriesData.data[dataPointIndex].x, seriesData.name, value)
      }
    },
    formatData() {
      let formattedData = [
        {
          name: this.$t('pages.review.reviewAnalyticsPage.answerTimeAverageByMonth.series'),
          data: []
        }
      ]

      this.data.forEach((d) => {
        const date = `${this.$t(`global.months.${d.month}`)} ${d.year}`

        formattedData[0].data.push({
          x: date,
          y: d.answer_time_average_by_month
        })
      })

      this.formattedData = formattedData
    }
  }
}
</script>
